import { createSlice } from '@reduxjs/toolkit';

interface AmountCard {
  title: string;
  value: number;
  percentage: number;
}

interface ChartState {
  currentBalancePerBank: AmountCard;
  balancePerAccountType: AmountCard;
}

const initialState: ChartState = {
  currentBalancePerBank: {
    title: '',
    value: 0,
    percentage: 0,
  },
  balancePerAccountType: {
    title: '',
    value: 0,
    percentage: 0,
  },
};

export const chartSlice = createSlice({
  name: 'chart',
  initialState,
  reducers: {
    onSetDataAmountCard: (state, action) => {
      state.currentBalancePerBank = action.payload;
    },
    onSetDataAmountPerTypeAcc: (state, action) => {
      state.balancePerAccountType = action.payload;
    },
  },
});

export const { onSetDataAmountCard, onSetDataAmountPerTypeAcc } =
  chartSlice.actions;
